import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { catchError, throwError, timeout, TimeoutError } from 'rxjs';

/** Max wait for a backend request during the server render (ms). */
const SSR_REQUEST_TIMEOUT_MS = 15_000;

/**
 * Fails a server-render request that takes longer than {@link SSR_REQUEST_TIMEOUT_MS} with HTTP 504, so a slow
 * backend cannot hold the render and the caller handles it like any other error (the page renderer answers with
 * the status instead of a blank page). Every other error (404, 5xx, …) reaches the caller unchanged.
 * @param req The outgoing request.
 * @param next The next handler in the chain.
 * @returns The response stream, failing with a 504 `HttpErrorResponse` on timeout.
 */
export const ssrTimeoutInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isPlatformServer(inject(PLATFORM_ID))) return next(req);
  return next(req).pipe(
    timeout(SSR_REQUEST_TIMEOUT_MS),
    catchError((error: unknown) => {
      if (!(error instanceof TimeoutError)) return throwError(() => error);
      console.warn(`SSR HTTP request timeout for: ${req.url}`);
      return throwError(() => new HttpErrorResponse({ status: HttpStatusCode.GatewayTimeout, statusText: 'SSR request timeout', url: req.url }));
    })
  );
};
